module.exports = __webpack_public_path__ + "media/images/icon/white/ico_search-6ff119b390b7c3e63fc380dc6725e6c7.svg";